import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Button, Center, Heading, Spinner, Text, VStack } from '@chakra-ui/react';
import { Paragraph } from '@src/components/sco/Paragraph';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { gql } from '@src/lib/gql';
import React from 'react';
export type ManageRequestAuthGateProps = {
  children?: any;
  groupRequestId: string;
};
export const ManageRequestAuthGate: React.FC<ManageRequestAuthGateProps> = props => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($groupRequestId: String) {
        groupRequest(groupRequestId: $groupRequestId) {
          id
          canUserEdit
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !props.groupRequestId;
  let t2;
  if ($[1] !== props.groupRequestId) {
    t2 = {
      groupRequestId: props.groupRequestId
    };
    $[1] = props.groupRequestId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      skip: t1,
      variables: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const query = useQuery(t0, t3);
  if (!props.groupRequestId) {
    let t4;
    if ($[6] !== props.children) {
      t4 = <>{props.children}</>;
      $[6] = props.children;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (query.data?.groupRequest?.canUserEdit) {
    let t4;
    if ($[8] !== props.children) {
      t4 = <>{props.children}</>;
      $[8] = props.children;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (query.data?.groupRequest?.canUserEdit === false) {
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Center padding={4} width="full"><Paragraph>Not Authorized</Paragraph></Center>;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  if (query.error) {
    let t4;
    if ($[11] !== query.error) {
      t4 = query.error.toString();
      $[11] = query.error;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t5;
    if ($[13] !== t4) {
      t5 = <Center padding={4} width="full"><Paragraph>{"Error: "}{t4}</Paragraph></Center>;
      $[13] = t4;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  if (!query.loading && !query.data?.groupRequest) {
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <RequestNotFound />;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    return t4;
  }
  let t4;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Center padding={4} width="full"><Spinner /></Center>;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export const RequestNotFound = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading size="lg">We couldn't find that goal</Heading>;
    t1 = <Text color="colorPalette.fg/60" fontSize="sm">The link may be wrong, or the goal was deleted.</Text>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Center height="full" padding={8} width="full"><VStack gap={3} maxWidth="md" textAlign="center">{t0}{t1}<Button asChild={true} size="sm" variant="cta"><NextLink href="/requests/manage">Go to your goals</NextLink></Button></VStack></Center>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};